module.exports = __webpack_public_path__ + "img/profile-sem-foto.d30e15a2.png";